<template>
    <div class="tabber" v-if="tabhidde">
       <ul>
           <li>
               <router-link to="/">
                <img style="width:80%;max-width:0.52rem;" :src="routername == '/' ? ' ../../static/mobile/shouye1.png' : '../../static/mobile/shouye.png'" alt="">
                <span :style="routername == '/' ? 'color:#AB0000' : '' ">首页</span>
               </router-link>
           </li>
           <li>
                <router-link to="/Security">
                <img style="width:80%;max-width:0.46rem;" :src="routername == '/Security' ? ' ../../static/mobile/fwcx1.png' : '../../static/mobile/fwcx.png'" alt="">
                <span :style="routername == '/Security' ? 'color:#AB0000' : '' ">防伪查询</span>
               </router-link>
           </li>
           <li> 
                <router-link to="/Authorization">
                <img style="width:80%;max-width:0.51rem;" :src="routername == '/Authorization' ? ' ../../static/mobile/sqcx1.png' : '../../static/mobile/sqcx.png'" alt="">
                <span :style="routername == '/Authorization' ? 'color:#AB0000' : '' ">授权查询</span>
               </router-link>
            </li>
           <li>
                <router-link to="/Brand">
                <img style="width:80%;max-width:0.47rem;" :src="routername == '/Brand' ? ' ../../static/mobile/pinpai1.png' : '../../static/mobile/pinpai.png'" alt="">
                <span :style="routername == '/Brand' ? 'color:#AB0000' : '' ">品牌</span>
               </router-link>
           </li>
      
       </ul>
    </div>
</template>

<script>
export default {
    name: 'NewLiuyanShopWebTabbar',

    data() {
        return {
            tabhidde:true,
            routername:'',
        };
    },

    mounted() {
          let routername = this.$route.path;
          this.routername = routername
            if(routername === '/Product' || routername === '/Shopping'){
            }

    },

    methods: {
        
    },
};
</script>

<style lang="less" scoped>
.tabber{
    width: 100%;
    height:1rem;
    position: fixed;
    bottom: 0;
    z-index: 222;
    background: url("../../static/mobile/navbg.png")no-repeat;
    background-size: 100% 100%;
  ul{
    width: 100%;
    height: 1rem;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    padding-top: 0.1rem;
    li{
        width: 25%;
        height: 1rem;
        text-align: center;
      a{
          display: inline-block;
          height: 1rem;
          letter-spacing:0;
            i{
            display: inline-block;
        }
        span{
            display: inline-block;
            width: 100%;
           font-size:0.21rem;
           font-weight: bold;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TabBar.vue